export const ModuleContext = 'context';
export const ModuleOption = 'option';
export const ModuleDashboard = 'dashboard';
export const ModuleApplication = 'application';

/**
 * Danh sách module của chương trình
 */
export const AppModules = [ModuleContext, ModuleDashboard, ModuleApplication];
